import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useInstallStore = defineStore('install', () => {
    const selectedInstall = ref(null);

    function setCurrentInstall(event) {
        selectedInstall.value = event;
    }
    function getCurrentInstall() {
        return selectedInstall.value;
    }

    return {
        selectedInstall,
        setCurrentInstall,
        getCurrentInstall
    };
});